export const DEFAULT_ZOOM_LEVEL = 0.8;
// Toggle off once legacy workspace pages no longer need the 80% app zoom baseline.
export const ENABLE_LEGACY_SHELL_ZOOM_COMPENSATION = true;

export const ZOOM_CONFIG = {
  MIN: 0.65,
  MAX: 1.25,
  DEFAULT: DEFAULT_ZOOM_LEVEL,
  EXPORT_MODE: 1,
  STEP: 0.05,
  STORAGE_KEY: 'scalar-app-zoom-level',
} as const;
